import React from "react";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@material-ui/core";

import { KeyValueArray } from "./KeyValueArray";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

export function Academics() {
  const { collegeId } = useParams();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  if (loading) {
    return (
      <Box>
        <CircularProgress style={{ color: "#3699FF" }} />
      </Box>
    );
  }

  let collegeDetails = !error ? JSON.parse(data.getCollegeInfo) : {};
  function replaceValue(value) {
    if (value === true) {
      return "yes";
    } else if (value === false) {
      return "no";
    }
    return value;
  }
  const mainInfo = [
    {
      key: "fourYearGraduationRate",
      value: replaceValue(
        collegeDetails.fourYearGraduationRate
          ? (collegeDetails.fourYearGraduationRate * 100).toFixed(2) + " %"
          : "--"
      ),
    },
    {
      key: "gpaRequirement",
      value: replaceValue(collegeDetails.gpaRequirement),
    },
    {
      key: "rankingsBestCollegeAcademics",
      value: replaceValue(collegeDetails.rankingsBestCollegeAcademics),
    },
    {
      key: "rankingsBestCollegeProfessors",
      value: replaceValue(collegeDetails.rankingsBestCollegeProfessors),
    },
    {
      key: "calendarSystem",
      value: replaceValue(collegeDetails.calendarSystem),
    },
  ];

  const classSizeRange = [
    {
      key: "classSizeRange10To19",
      title: "class Size Range 10 To 19",
      value: replaceValue(collegeDetails.classSizeRange10To19),
    },
    {
      key: "classSizeRange20To29",
      title: "class Size Range 20 To 29",
      value: replaceValue(collegeDetails.classSizeRange20To29),
    },
    {
      key: "classSizeRange2To9",
      title: "class Size Range 2 To 9",
      value: replaceValue(collegeDetails.classSizeRange2To9),
    },
    {
      key: "classSizeRange30To39",
      title: "class Size Range 30 To 39",
      value: replaceValue(collegeDetails.classSizeRange30To39),
    },
    {
      key: "classSizeRange40To49",
      title: "class Size Range 40 To 49",
      value: replaceValue(collegeDetails.classSizeRange40To49),
    },
    {
      key: "classSizeRange50To99",
      title: "class Size Range 50 To 99",
      value: replaceValue(collegeDetails.classSizeRange50To99),
    },
    {
      key: "classSizeRangeOver100",
      title: "class Size Range Over 100",
      value: replaceValue(collegeDetails.classSizeRangeOver100),
    },
  ];

  const otherInfo = [
    {
      key: "gpaBottomTenPercent",
      value: replaceValue(collegeDetails.gpaBottomTenPercent),
    },
    {
      key: "numberOfFullTimeFaculty",
      value: replaceValue(collegeDetails.numberOfFullTimeFaculty),
    },
    {
      key: "numberOfPartTimeFaculty",
      value: replaceValue(collegeDetails.numberOfPartTimeFaculty),
    },
    {
      key: "offersStudyAbroad",
      value: replaceValue(collegeDetails.offersStudyAbroad),
    },
    {
      key: "studentFacultyRatio",
      value: replaceValue(collegeDetails.studentFacultyRatio),
    },
    {
      key: "undergraduateSize",
      value: replaceValue(collegeDetails.undergraduateSize),
    },
  ];

  return (
    <>
      <Card className="mb-5">
        <CardContent>
          <Typography variant="h4" className="text-center" color="primary">
            {collegeDetails.name + " Academics"}
          </Typography>
        </CardContent>
      </Card>

      <Card className="mb-5">
        <CardContent>
          <Typography variant="h6" className="ml-2 text-center" color="primary">
            {" "}
            Academics Statistics{" "}
          </Typography>
          <Grid container spacing={8}>
            <Grid item sm={6}>
              <KeyValueArray
                data={mainInfo.slice(0, Math.ceil(mainInfo.length / 2))}
              />
            </Grid>
            <Grid item sm={6}>
              <KeyValueArray
                data={mainInfo.slice(Math.ceil(mainInfo.length / 2))}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" className="text-center" color="primary">
            About the classes
          </Typography>
          <Grid container spacing={8}>
            <Grid item sm={6}>
              <KeyValueArray data={classSizeRange} />
            </Grid>
            <Grid item sm={6}>
              <KeyValueArray data={otherInfo} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
